// https://gist.github.com/MartijnHols/e9f4f787efa9190885a708468f63c5bb
import { useEffect } from 'react';

export const useOnScreenKeyboardScrollFix = (isSafari: boolean) => {
    useEffect(() => {
        const handleScroll = () => {
            window.scrollTo(0, 0);
        };

        if (isSafari) window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isSafari]);
};
